import type { RouteRecordRaw } from 'vue-router'

export const toolsRoutes: RouteRecordRaw[] = [
  {
    path: '/tools/share',
    name: 'tools:share',
    component: () => import('./views/ShareToolView.vue'),
    meta: { title: 'Share', requiresAuth: false },
  },
  {
    path: '/tools/subtitles',
    name: 'tools:subtitles',
    component: () => import('./views/SubtitlesToolView.vue'),
    meta: { title: 'Subtitles', requiresAuth: false },
  },
]
